/**
 * Deterministically generates a property color using the same golden-angle HSL
 * sequence as the analytics tours chart. This scales to any number of properties
 * without repeating a fixed palette.
 */

export const CANCELED_TOUR_COLOR = '#bcc2c9';

/**
 * :param index: the property's position in the team's property list
 * :returns: a stable generated display color for that property
 */
export const getPropertyColor = (index: number): string => {
    const hue = (index * 137) % 360;
    return `hsl(${hue}, 60%, 58%)`;
};
